export const escUndefinedInStringHelper = (text) =>
  text.replace(/\bundefined\b/g, "");
